import Schema from 'rsuite/Schema';

const VALIDATION_MODEL = Schema.Model({
  name: Schema
    .Types
    .StringType()
    .isRequired('Please enter your name'),
  phone:Schema
    .Types
    .StringType()
    .isRequired('Please enter your phone number'),
  email: Schema
    .Types
    .StringType()
    // .isEmail('Please specify a valid email address')
    .addRule((value) => {
      let regEmail = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
      let cnoMatch = /^cno\:\d+$/i.test(value);
      let tnoMatch = /^tno\:\d+$/i.test(value);
      let emailMatch = regEmail.test(value);
      let isValidField = cnoMatch || tnoMatch || emailMatch;
      return isValidField;
    }, 'Please specify a valid email address')
    .isRequired('Please enter your email'),
  textarea: Schema
    .Types
    .StringType()
    .isRequired('Please enter your message'),
  isConsentProcessing: Schema
    .Types
    .BooleanType()
    .addRule((value) => value, 'Please confirm that you agree to the Privacy Policy.'),
  isFileLoadingProcessing: Schema
    .Types
    .BooleanType()
    .addRule((value) => {
        return !value;
    }, 'Please wait till file upload is finished')
    .isRequired('Please wait till file upload is finished')
});

export default VALIDATION_MODEL;

export const VALIDATION_MODEL_ESTIMATE = Schema.Model({
    name: Schema
        .Types
        .StringType()
        .isRequired('Please enter your name'),
    email: Schema
        .Types
        .StringType()
        // .isEmail('Please specify a valid email address')
        .addRule((value) => {
            let regEmail = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
            let cnoMatch = /^cno\:\d+$/i.test(value);
            let tnoMatch = /^tno\:\d+$/i.test(value);
            let emailMatch = regEmail.test(value);
            let isValidField = cnoMatch || tnoMatch || emailMatch;
            return isValidField;
        }, 'Please specify a valid email address')
        .isRequired('Please enter your email'),
    textarea: Schema
        .Types
        .StringType()
        .isRequired('Please enter your message'),
    isConsentProcessing: Schema
        .Types
        .BooleanType()
        .addRule((value) => value, 'Please confirm that you agree to the Privacy Policy.'),
    isFileLoadingProcessing: Schema
        .Types
        .BooleanType()
        .addRule((value) => {
            return !value;
        }, 'Please wait till file upload is finished')
        .isRequired('Please wait till file upload is finished')
});